export default __webpack_public_path__ + "static/media/logo_POV.58fbdd1b.svg";